import React from "react";
import MaterialIcon from "../BuilderComponents/MaterialIcon";

const IconPreview = ({ config, classes = "" }) => {
  const icon = config?.icon_class?.split(" ")[0] || "";

  // Only match font variant (not weight or size)
  const variantMatch = classes.match(/z-material-symbols-(outlined|rounded|sharp)/);
  const fontVariant = variantMatch?.[1] || "outlined";

  if (!icon) return null;

  return (
    <div className={`d_flex align_center justify_center ${classes}`} style={{ height: "100%" }}>
      <MaterialIcon
        name={icon}
        type={fontVariant}
        className={`z-material-symbols ${classes}`}
        style={{ border: "none", boxShadow: "none" }}
      />
    </div>
  );
};

export default IconPreview;
